import { render, staticRenderFns } from "./EduCourseMerterial.vue?vue&type=template&id=7fc6fd7d&scoped=true"
import script from "./EduCourseMerterial.vue?vue&type=script&lang=js"
export * from "./EduCourseMerterial.vue?vue&type=script&lang=js"
import style0 from "./EduCourseMerterial.vue?vue&type=style&index=0&id=7fc6fd7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc6fd7d",
  null
  
)

export default component.exports